import { Icons } from './Icons';
import { LINKS } from '../constants';
import { useInView } from '../hooks';
import styles from './Products.module.css';

function ProductCard({ icon: IconComp, badge, title, body, btn, href, accent, delay }) {
  const [ref, inView] = useInView(0.15);
  return (
    <div
      ref={ref}
      className={styles.card}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : 'translateY(20px)',
        transition: `all 0.6s ease ${delay}s`,
      }}
    >
      <div className={styles.cardTop}>
        <div className={styles.iconWrap} style={{ background: `${accent}18`, color: accent }}>
          <IconComp />
        </div>
        <span className={styles.badge} style={{ color: accent, borderColor: `${accent}40` }}>
          {badge}
        </span>
      </div>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardBody}>{body}</p>
      <a href={href} target="_blank" rel="noopener noreferrer" className={styles.cardBtn}>
        {btn} <Icons.Arrow />
      </a>
    </div>
  );
}

export default function Products({ t }) {
  const [ref, inView] = useInView(0.1);

  const cards = [
    {
      icon: Icons.Swap,
      badge: t.dexBadge,
      title: t.dexTitle,
      body: t.dexBody,
      btn: t.dexBtn,
      href: LINKS.velarionDex,
      accent: '#3B82F6',
      delay: 0,
    },
    {
      icon: Icons.Bolt,
      badge: t.energyBadge,
      title: t.energyTitle,
      body: t.energyBody,
      btn: t.energyBtn,
      href: LINKS.tronEnergySite,
      accent: '#06B6D4',
      delay: 0.12,
    },
    {
      icon: Icons.Bolt,
      badge: t.botBadge,
      title: t.botTitle,
      body: t.botBody,
      btn: t.botBtn,
      href: LINKS.tronEnergyBot,
      accent: '#3B82F6',
      delay: 0.24,
    },
  ];

  return (
    <section className={styles.section} id="products">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>
        </div>

        <div className={styles.grid}>
          {cards.map(c => <ProductCard key={c.title} {...c} />)}
        </div>
      </div>
    </section>
  );
}
